export default {
  videos: {
    items: {},
    /** Each new video would be added to the  */
    videoQueue: {
      /** Example Object */
      // id : {
      //  zIndex: 2000
      //  status: 'loading' || 'ready'
      // },
    },
    active: false
  },
}